export enum CHAT_MESSAGE_STATUSES {
  ERROR = 'error',
  PENDING = 'pending',
  DELIVERED = 'delivered',
}
